import { useEffect, useState } from "react";
import { Flex, Box } from "rebass/styled-components";
import { useHistory } from "react-router-dom";
import ReactPlaceholder from "react-placeholder";
import { TextRow } from "react-placeholder/lib/placeholders";
import styled from "styled-components";
import { FiCopy } from "react-icons/fi";

import theme from "../../theme/themeThree";
import { Title1, Headline } from "../text";
import { getUserGroupStyle } from "../../MVVM/Utilities/User";
import { useShouldShowSubscriptionOverhaul } from "MVVM/Hooks/useSubscriptionOverhaul";
import { useHover } from "../../hooks";
import { Avatar } from "MVVM/Components/AvatarV2";

const ownerPlaceholder = (
  <>
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        marginTop: `${theme.space[5]}px`,
        height: theme.text.large3.fontSize,
        width: "100%",
        maxWidth: "330px",
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: theme.text.title2.fontSize,
        width: "80%",
        maxWidth: "150px",
        marginTop: `${theme.space[2]}px`,
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: theme.text.headline.fontSize,
        width: "80%",
        maxWidth: "200px",
        marginTop: `${theme.space[2]}px`,
      }}
    />
  </>
);

const StyledFlex = styled(Flex)`
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;
`;

const StyledTitle = styled(Title1)`
  font-weight: 500;
  transition-property: color;
  transition-duration: 0.15s;
  @media (max-width: 1300px) {
    font-size: 24px;
  }
  @media (max-width: 375px) {
    font-size: 20px;
  }
`;

const StyledHeadline = styled(Headline)`
  @media (max-width: 1300px) {
    font-size: 16px;
  }
`;

export function UserHero({ user, displayName, loading = false }) {
  const [noticeDisplayed, setNoticeDisplayed] = useState(false);
  const [hoverRef, isHovered] = useHover();
  const history = useHistory();

  const showSubscriptionOverhaul = useShouldShowSubscriptionOverhaul();
  const groupDisplay = getUserGroupStyle(
    user.userGroup?.type,
    showSubscriptionOverhaul,
  ).display;

  useEffect(() => {
    if (noticeDisplayed) {
      setTimeout(() => {
        setNoticeDisplayed(false);
      }, 3000);
    }
  }, [noticeDisplayed]);

  return (
    <StyledFlex flexDirection="row">
      <Avatar
        rank={user?.rank}
        userGroup={user?.userGroup?.type}
        src={user?.avatar}
        size="lg"
      />
      <StyledNameSection
        ml={4}
        alignItems="flex-start"
        justifyContent="flex-start"
      >
        <ReactPlaceholder customPlaceholder={ownerPlaceholder} ready={!loading}>
          <NameAndTitle
            ref={hoverRef}
            onClick={() => {
              history.push(`/u/${user._id}`);
            }}
          >
            <StyledTitle color={isHovered ? "envy" : null}>
              {displayName ? displayName : "Allstar User"}
            </StyledTitle>
            <StyledHeadline textAlign="left" mt={1} color="chalk">
              {groupDisplay}
            </StyledHeadline>
          </NameAndTitle>
          <Flex
            title="Copy Link to Profile"
            alignItems={"center"}
            mt={[2, 2, 3, 3]}
            ml={3}
          >
            <CopyIcon
              title="Copy Link to Profile"
              size={16}
              onClick={() => {
                setNoticeDisplayed(true);
                window.navigator.clipboard.writeText(
                  `https://allstar.gg/u/${user._id}`,
                );
              }}
            />
          </Flex>
        </ReactPlaceholder>

        {noticeDisplayed && <Notice>Link Copied!</Notice>}
      </StyledNameSection>
    </StyledFlex>
  );
}

const CopyIcon = styled(FiCopy)`
  color: ${theme.colors.chalk};
  &:hover {
    cursor: pointer;
    color: ${theme.colors.envy};
  }
`;

const StyledNameSection = styled(Flex)`
  justify-content: space-between;
  flex-direction: row;
  @media (max-width: 1300px) {
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
`;

const NameAndTitle = styled(Box)`
  &:hover {
    cursor: pointer;
  }
`;

const Notice = styled(Box)`
  background-color: ${theme.colors.midnightAlpha50};
  padding: 5px;
  position: absolute;
  right: -100px;
  top: 0px;
  border-radius: 5px;
`;
